// Library Imports
import React from 'react'
// Component Imports
import PageBanner from '../../components/banner/PageBanner'
import AboutHistory from './AboutHistory'

function About() {
    return (
      <div className='aboutpage'>
        <PageBanner pageName="About Us" />
        <AboutHistory />
      </div>
    )
  }

export default About